import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import {
  StyledTabs,
  StyledTab,
  StyledTabsBlue,
  StyledTabBlue,
} from 'components/MyContractsTabs/styles';
import GATracking, { EVENT_ACTION } from 'helpers/GATracking';
import { getLocaleSelector } from 'store/LanguageProvider/selectors';
import { useSelector } from 'react-redux';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`my-contracts-tabpanel-${index}`}
      aria-labelledby={`my-contracts-tab-${index}`}
      {...other}
    >
      {value === index && <Box paddingTop={0.6}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `my-contracts-tab-${index}`,
    'aria-controls': `my-contracts-tabpanel-${index}`,
  };
}

export interface tabItemProps {
  label: string;
  content: React.ReactNode;
  contractNumber: string;
  circulationDate: string;
}

const MyContractsTabs = (props: {
  category: string;
  label: string;
  tabItems: tabItemProps[];
  getDetailContract?: Function;
  isLoadingDetailContract: boolean;
  isEpargn?: boolean;
  selectedPolice?: string;
}) => {
  const [value, setValue] = React.useState(0);

  React.useEffect(() => {
    if (props.selectedPolice) {
      /* istanbul ignore next */
      const selectedIndex =
        props.tabItems.findIndex(
          /* istanbul ignore next */ (tab) =>
            tab.label === props.selectedPolice,
        ) || 0;
      /* istanbul ignore next */
      props.getDetailContract &&
        props.getDetailContract({
          policyNumbers: [props.tabItems[selectedIndex].label],
          language,
        });
      /* istanbul ignore next */
      setValue(selectedIndex);
    }
  }, [props.selectedPolice]);

  const language = useSelector(getLocaleSelector);

  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    props.getDetailContract &&
      props.getDetailContract({
        policyNumbers: [props.tabItems[newValue].label],
        language,
      });
    setValue(newValue);
  };

  return (
    <>
      {props.isEpargn ? (
        <StyledTabsBlue
          value={value}
          onChange={handleChange}
          aria-label="my contracts tabs"
        >
          {props.tabItems.map((tab: tabItemProps, index) => (
            <StyledTabBlue
              key={index}
              label={tab.label}
              {...a11yProps(index)}
              disableRipple
            />
          ))}
        </StyledTabsBlue>
      ) : (
        <StyledTabs
          value={value}
          onChange={handleChange}
          aria-label="my contracts tabs"
        >
          {props.tabItems.map((tab: tabItemProps, index) => (
            <StyledTab
              key={index}
              label={tab.label}
              {...a11yProps(index)}
              disableRipple
            />
          ))}
        </StyledTabs>
      )}

      {props.isLoadingDetailContract ? (
        (GATracking.event(props.category, EVENT_ACTION.LOAD, props.label),
        (
          <Skeleton
            data-testid="loader"
            variant="rect"
            width={767}
            height={154}
          />
        ))
      ) : (
        <>
          {props.tabItems.map((tab: tabItemProps, index) => (
            <TabPanel key={index} value={value} index={index}>
              {tab.content}
            </TabPanel>
          ))}
        </>
      )}
    </>
  );
};

export default MyContractsTabs;
